import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';

@Component({
  selector: 'app-descripcion-funcion-pagos',
  templateUrl: './descripcion-funcion-pagos.component.html',
  styleUrls: ['./descripcion-funcion-pagos.component.scss'],
})
export class DescripcionFuncionPagosComponent implements OnInit {
  @Input() User;
  @Input() IdRolPago = ""
  SoyTutor = false;
  constructor(public modal: ModalController, private conexion: ConexionService, 
    private utilidades: UtilidadesService) { }

  ngOnInit() {}

  CambiarRolUsuario() {
    this.utilidades.Loading("Solicitando función de pagos")
    this.User.Roles.push(this.IdRolPago)
    this.conexion.CambiarRolUsuario(this.User.Id, this.User.Roles, true).subscribe((resp) => {
      this.utilidades.CerrarLoading()
     this.utilidades.Toast("Función agregada exitosamente")
     this.utilidades.Nav("/home")
     setTimeout(() => {
      location.reload()
     }, 2000);
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }


}
